export const exportConfig = {
  exportUrl: '/product/fa/export',
  exportName: 'featuresAdoption',
  exportFormat: 'zip'
};

export const tableConf = [
  {
    isSortable: true,
    field: 'companyName',
    title: 'Company Name'
  },
  {
    isSortable: false,
    field: 'tm',
    title: 'TM'
  },
  {
    isSortable: false,
    field: 'ps',
    title: 'PS'
  },
  {
    isSortable: true,
    field: 'plan',
    title: 'Pricing Plan'
  },
  {
    isSortable: true,
    field: 'billingCycle',
    title: 'Billing Cycle'
  },
  {
    isSortable: true,
    field: 'arr',
    title: 'ARR',
    fromToGroup: true
  },
  {
    isSortable: true,
    field: 'firstPaymentDate',
    title: 'First Payment'
  },
  {
    isSortable: false,
    field: 'industry',
    title: 'Industry'
  },
  {
    isSortable: true,
    field: 'accountManager',
    title: 'Account Manager'
  },
  {
    isSortable: true,
    field: 'customerSuccessEngineer',
    title: 'CS Engineer'
  }
];

// export const charts = {
//   chart: ['timeToAdoption', 'featureUsage'],
//   chartLabel: ['Time to Adoption', 'Feature Usage']
// };

export const charts = {
  chart: ['featureUsage'],
  chartLabel: ['Feature Usage']
};

export const zeroFeatures = [
  'cat_idp',
  'cat_tfa',
  'cat_nf',
  'cat_clients',
  'cat_app',
  'cat_sf',
  'cat_dashboards',
  'cat_siem'
];
